import { IChatDriver } from '@app/dashboard/messaging/message-list/windows.component';

import { CoachingFeatureFlagService } from '@services/feature-flags/coaching';
import { Session } from '@services/session';

import { SAFETY_TABS_URL } from '@lib/safety/safety';

import { IAssignedCoach, IAssignedCoachParticipants } from './coaching.interface';

import { Role } from '@lib/roles.const';
import { COACHING_URL_PREFIX } from '@coaching/coaching.consts';

export function getCoachIds(coaches: IAssignedCoach[]): string {
  return (coaches || []).map((coach: IAssignedCoach): number => coach.id).join();
}

export function getAssignedCoachChatParticipants(assignedCoaches: IAssignedCoach[]): IAssignedCoachParticipants {
  if (!assignedCoaches?.length) return;

  const coaches: IChatDriver[] = mapCoachesToIChatDriver(assignedCoaches);
  const primaryParticipant: IChatDriver = coaches[0];
  const extraParticipants: IChatDriver[] = coaches.slice(1);
  return { primaryParticipant, extraParticipants };
}

function mapCoachesToIChatDriver(assignedCoaches: IAssignedCoach[]): IChatDriver[] {
  return (assignedCoaches || []).map((coach: IAssignedCoach): IChatDriver => ({
    id: coach.id.toString(),
    name: coach.name,
    first_name: coach.firstName,
    last_name: coach.lastName,
    role: Role.DISPATCHER,
  }));
}

export function getCoachingUrlPrefix(coachingFeatureFlagService: CoachingFeatureFlagService): string {
  return coachingFeatureFlagService.isComplianceCoachingEnabled() ? COACHING_URL_PREFIX : SAFETY_TABS_URL.COACHING;
}

export function hasCoachingAccess(
  session: Session,
  coachingFeatureFlagService: CoachingFeatureFlagService,
): boolean {
  let isCoachingHubAllowed: boolean;

  if (coachingFeatureFlagService?.isCoachingPermissionsByRoleEnabled()) {
    isCoachingHubAllowed = session.userPermissions.isAllowedToConductEventsCoaching() || session.userPermissions.isAllowedToConductLogsCoaching();
  } else {
    isCoachingHubAllowed = session.isCoachingHubAllowed();
  }

  return session.isDispatcher() && coachingFeatureFlagService?.isComplianceCoachingEnabled() && isCoachingHubAllowed;
}